export const PrintOptions = [
	{
		name: 'Letter',
		size: 'letter',
		eventName: 'letter'
	},
	{
		name: 'Legal',
		size: 'legal',
		eventName: 'legal'
	},
	{
		name: 'Tabloid',
		size: 'tabloid',
		eventName: 'tabloid'
	},
	{
		name: '18\" x 24\"',
		size: 'arch-c',
		eventName: '18\" x 24\"'
	},
	{
		name: '24\" x 36\"',
		size: 'arch-d',
		eventName: '24\" x 36\"'
	},
	{
		name: 'iPad Retina',
		size: 'iPad',
		eventName: 'retina'
	}
];


// WEBPACK FOOTER //
// ./src/app/constants/PrintOptions.ts